window.ffNativeMounts ??= {};
window.ffNativeMounts["riders"] = (controller) => {
    (() => {
        const media = [...document.querySelectorAll('.rr-player')], original = new Map(media.map(m => [m, m.innerHTML]));
        const closeVideo = (frame, returnFocus = false) => {
            if (!frame || !original.has(frame)) return;
            frame.innerHTML = original.get(frame);
            if (returnFocus) frame.querySelector('[data-video-play]')?.focus({ preventScroll: true });
        };
        document.addEventListener('click', e => {
            const close = e.target.closest('[data-ff-r6-close-film]');
            if (close) {
                e.preventDefault();
                closeVideo(close.closest('.rr-player'), true);
                return;
            }
            const link = e.target.closest('[data-video-play]');
            if (!link || e.metaKey || e.ctrlKey || e.altKey || e.shiftKey)
                return;
            e.preventDefault();
            let frame = link.closest('.rr-player'), p = document.createElement('iframe');
            media.filter(other => other !== frame && other.querySelector('iframe')).forEach(other => closeVideo(other));
            p.src = frame.dataset.vimeo ? 'https://player.vimeo.com/video/' + frame.dataset.vimeo + '?h=22c34dab05&autoplay=1&dnt=1' : 'https://www.youtube-nocookie.com/embed/' + frame.dataset.youtube + '?autoplay=1&rel=0';
            p.title = frame.dataset.title;
            p.allow = 'autoplay; encrypted-media; fullscreen; picture-in-picture';
            p.allowFullscreen = true;
            p.referrerPolicy = 'strict-origin-when-cross-origin';
            const closeButton = document.createElement('button');
            closeButton.type = 'button';
            closeButton.className = 'button white';
            closeButton.dataset.ffR6CloseFilm = '';
            closeButton.textContent = 'Close video';
            closeButton.setAttribute('aria-label', 'Close video: ' + frame.dataset.title);
            Object.assign(closeButton.style, { position: 'absolute', top: '12px', right: '12px', zIndex: '1' });
            frame.replaceChildren(p, closeButton);
            p.focus();
        }, Object.assign({}, { signal: controller.signal }, { signal: controller.signal }));
        const filters = [...document.querySelectorAll('[data-film-filter]')];
        filters.forEach(button => button.addEventListener('click', () => {
            filters.forEach(b => b.setAttribute('aria-pressed', String(b === button)));
            let n = 0;
            document.querySelectorAll('.rr-film-card').forEach(card => {
                let show = button.dataset.filmFilter === 'all' || card.dataset.activity === button.dataset.filmFilter;
                card.hidden = !show;
                if (show)
                    n++;
                else {
                    let frame = card.querySelector('.rr-player');
                    if (frame.querySelector('iframe')) closeVideo(frame);
                }
            });
            document.getElementById('film-count').textContent = n + ' ' + (n === 1 ? 'film' : 'films');
        }, Object.assign({}, { signal: controller.signal }, { signal: controller.signal })));
        controller.signal.addEventListener('abort', () => media.filter(frame => frame.querySelector('iframe')).forEach(frame => closeVideo(frame)), { once: true });
    })();
};
